import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLightbulb16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLightbulb16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.879 8.893a1 1 0 0 0-.504.868v1.475a.5.5 0 0 1-.5.5h-1.75a.5.5 0 0 1-.5-.5V9.761a1 1 0 0 0-.504-.868 4 4 0 0 1-.469-.317A3.67 3.67 0 0 1 4.25 5.695C4.25 3.665 5.918 2 8 2s3.75 1.665 3.75 3.695c0 1.161-.543 2.2-1.402 2.88a4 4 0 0 1-.47.318m-4.254 2.343V9.761a5 5 0 0 1-.594-.401 4.67 4.67 0 0 1-1.78-3.665C3.25 3.102 5.377 1 8 1s4.75 2.102 4.75 4.695a4.67 4.67 0 0 1-1.781 3.665 5 5 0 0 1-.594.401v1.475a1.5 1.5 0 0 1-1.5 1.5h-1.75a1.5 1.5 0 0 1-1.5-1.5m.89 2.76a.5.5 0 0 0 0 1h2.97a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLightbulb16);
